import React from "react";
import { Link } from "react-router-dom";

const CaseManagementHome = ({ benchId }) => {
  return (
    <>
      <div className="important-cards-are">
        <Link to="case-management-system/cause-list" className="imp-card">
          <img src="images/icon-clipboard.png" alt="" />
          <h5>Cause List</h5>
        </Link>
        <Link to="case-management-system/case-status" className="imp-card">
          <img src="images/icon-stamp.png" alt="" />
          <h5>Case Status</h5>
        </Link>
        <Link to="case-management-system/judgement" className="imp-card">
          <img src="images/icon-regulation.png" alt="" />
          <h5>Final Orders / Judgements</h5>
        </Link>
        {/* <Link to="case-management-system/case-search" className="imp-card">
          <img src="images/icon-law.png" alt="" />
          <h5>Case Search</h5>
        </Link> */}
        <Link to="case-management-system/daily-order" className="imp-card">
          <img src="images/icon-auction.png" alt="daily-order" />
          <h5>Daily Orders</h5>
        </Link>
        {/* <Link
          to="case-management-system/case-under-objection"
          className="imp-card"
        >
          <img src="images/icon-right-to-objection.png" alt="" />
          <h5>Case Under Objection</h5>
        </Link> */}
      </div>
    </>
  );
};

export default CaseManagementHome;
